export const timeOffStatuses = {
  EXPECTED: 'expected',
  CONFIRMED: 'confirmed',
  REJECTED: 'rejected',
}
